var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"app-content-heading"},[_vm._t("default"),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"app-content-heading__loader icon-loading-small"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }